import styled from 'styled-components';

export const TempErrorWrap = styled.div`
  width: 100%;
  height: 100vh;
  align-items: center;
  justify-content: center;
  text-align: center;
  display: flex;

  img {
    width: 120px;
    position: absolute;
    bottom: 40px;
    left: 50%;
    margin-left: -60px;
  }

  h2 {
    margin: 8px 0;
  }

  p {
    margin: 0;
  }
`;
